import React from 'react'

export default function PageUseZustland() {
  return (
    <div>
      <h1>Zustland</h1>
    </div>
  )
}
